import styled from 'styled-components'
import { colors, breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import { showImageModal } from '@/components/image-modal'
import { Avatar } from '@/components/avatar'
import { getImageUrl } from '@/utils/image'

const DataContainer = styled.div`
  display: grid;
  grid-template-columns: 164px 322px;
  grid-gap: 0 40px;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    grid-template-columns: 80px 1fr;
    grid-gap: 0 12px;
    padding: 0 12px;
  }
`
const AvatarContainer = styled.div`
  cursor: pointer;
`

const ItemsWrapper = styled.div`
  display: grid;
  grid-gap: 12px 0;
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    > :not(:last-child) {
      border-bottom: 1px solid ${colors.grey88};
    }
  }
`

const AvatarTableViewComponent = ({ data = {} }) => {
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const { items, avatar } = data
  const imageSize = displayMobile ? '80px' : '164px'

  return (
    <DataContainer>
      <AvatarContainer
        onClick={() =>
          showImageModal({
            src: getImageUrl(avatar?.aws_s3_key)
          })
        }
      >
        <Avatar
          width={imageSize}
          height={imageSize}
          location={getImageUrl(avatar?.aws_s3_key, {
            width: 164,
            height: 164
          })}
          radius={20}
        />
      </AvatarContainer>
      <ItemsWrapper>{items?.map(item => item?.cell)}</ItemsWrapper>
    </DataContainer>
  )
}

export default AvatarTableViewComponent
